import {
    DESTROY_ACCOUNT_START, GET_DESTROY_STATUS_START, GET_ACCOUNT_PII_START,
    GET_ACCOUNT_PII_STATUS_START, DELETE_SHARE_START
} from "./DeleteAccountActions";

import {
    DESTROY_ACCOUNT, GET_DESTROY_STATUS, GET_ACCOUNT_PII, GET_ACCOUNT_PII_STATUS,
    GET_ANY_MAIL_ACCOUNT_PII_STATUS, GET_ANY_MAIL_ACCOUNT_PII, DELETE_SHARE
} from "../../redux/types";

const INITIAL_STATE = {
    fetching: false,
    fetchingPii: false,
    fetchingPiiStatus: true,
    destroy: {},
    pii: {},
    piiStatus: {},
    brandsPii: {},
    deletingShare: false,
    deleteShareStatus: {}
};

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case DESTROY_ACCOUNT_START:
            return {...state, fetching: true, destroy: {}};
        case DESTROY_ACCOUNT:
            if(action.error){
                return {...state, fetching: false, destroy: {}}
            }
            return {...state, fetching: false, destroy: {}, pii: {}};
        case GET_DESTROY_STATUS_START:
            return {...state, fetching: true, destroy: {}};
        case GET_DESTROY_STATUS:
            if(action.error){
                return {...state, fetching: false, destroy: {}}
            }
            return {...state, fetching: false, destroy: action.payload.data};
        case GET_ACCOUNT_PII_START:
            return {...state, fetchingPii: true, pii: {}};
        case GET_ACCOUNT_PII:
            if(action.error){
                return {...state, fetchingPii: false, pii: {}}
            }
            const {data} = action.payload;
            return {...state, fetchingPii: false, pii: {...data, userInfo: data.userInfo && data.userInfo.filter(item => item.phone)}};
        case GET_ANY_MAIL_ACCOUNT_PII:
            if(action.error){
                return {...state, fetchingPii: false, pii: {}}
            }
            return {...state, fetchingPii: false, brandsPii: action.payload.data};
        case GET_ACCOUNT_PII_STATUS_START:
            return {...state, fetchingPiiStatus: true, piiStatus: false, pii: {}};
        case GET_ACCOUNT_PII_STATUS:
            if(action.error){
                return {...state, fetchingPiiStatus: false}
            }
            return {...state, fetchingPiiStatus: false, piiStatus: action.payload.data.isPiiExist};
        case GET_ANY_MAIL_ACCOUNT_PII_STATUS:
            if(action.error){
                return {...state, fetchingPiiStatus: false}
            }
            return {...state, fetchingPiiStatus: false, piiStatus: action.payload.data};

        case DELETE_SHARE_START:
            return {...state, deletingShare: true, deleteShareStatus: {}};
        case DELETE_SHARE:
            if(action.error){
                return {...state, deletingShare: false, deleteShareStatus: {result: "error"}}
            }

            if(state.pii && state.pii.uploadsInfo && action.payload && action.payload.data && action.payload.data.url){
                state.pii.uploadsInfo = state.pii.uploadsInfo.filter(obj => obj.url != action.payload.data.url)
            }
            
            return {...state, deletingShare: false, deleteShareStatus: action.payload.data}
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/containers/delete-account/DeleteAccountReducer.js